import type {AutoDeliveryImage} from '@/types/icc/autoDeliveryDetails';

export const IMAGE_VIEW_TYPES = {
    HI_RES: 'hi-res',
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small',
} as const;

export const getImageByViewType = (
    images: AutoDeliveryImage[] | null | undefined,
    viewType: string
): AutoDeliveryImage | undefined => {
    if (!images?.length) return undefined;

    const result = images.filter((image) => image.viewType?.toLowerCase() === viewType);

    return result[0];
};
